import React, { useContext, useEffect, useState } from "react";
import organisms from "../../../../components/organisms";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import service from "../../../../api/services";
import { HeaderHeading } from "../../../../Context";
import constant from "../../../../constants/constant";
import molecules from "../../../../components/molecules";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";

const { RoleLayout } = molecules;
const { Role } = organisms;
const Index = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const assignedTo = searchParams.get('role_for') || constant.ROLE_FOR[1].id;
    const [rolesList, setRolesList] = useState();
    const [subAdminRole, setSubAdminRole] = useState<{
        label: string;
        value: number;
        id:string;
    }>(constant.ROLE_FOR[0]);
    const { setHeader, setSidebar }: any = useContext(HeaderHeading);

    //function to get the role list
    const getRolesList = async () => {
        try {
            let response = await service.roles.list({
                role_for: subAdminRole?.value,
            });
            setRolesList(response.data);
        } catch (error) {
            console.error(error);
        }
    };
    //end

    //for handle the edit route
    const handleEdit = (id: string,value:string) => {
        navigate(`/setting/role/edit/${id}?assignedTo=${subAdminRole?.value}`);
    };
    //end

    //for handle the add route
    const handleAdd = (value:string) => {
        navigate(`/setting/role/add?assignedTo=${value}`);
    };
    //end

    const tabs = [
        {
            id: constant.ROLE_FOR[0].id,
            label: "Admin Role",
            target: "pane-one",
            Content: (
                <Role
                    rolesList={rolesList}
                    handleEdit={(id: string) => handleEdit(id,constant.ROLE_FOR[0].id)}
                    handleAdd={()=>handleAdd(constant.ROLE_FOR[0].id)}
                />
            ),
        },
        {
            id: constant.ROLE_FOR[1].id,
            label: "Store Role",
            target: "pane-two",
            Content: (
                <Role
                    rolesList={rolesList}
                    handleEdit={(id: string) => handleEdit(id,constant.ROLE_FOR[1].id)}
                    handleAdd={()=>handleAdd(constant.ROLE_FOR[1].id)}
                />
            ),
        },
        {
            id: constant.ROLE_FOR[3].id,
            label: "Staff Role",
            target: "pane-three",
            Content: (
                <Role
                    rolesList={rolesList}
                    handleEdit={(id: string) => handleEdit(id,constant.ROLE_FOR[3].id)}
                    handleAdd={()=>handleAdd(constant.ROLE_FOR[3].id)}
                />
            ),
        },
    ];

    const onChangeTab = (value: string) => {
        const requiredTab = constant.ROLE_FOR.find((item) => item?.id === value);
        if(requiredTab){
            navigate(`/setting/role?role_for=${value}`);
        }
        // requiredTab && setSubAdminRole(requiredTab);
    };

    useEffect(() => {
        setHeader("Setting - Roles");
        setSidebar(false);
    }, []);

    useEffect(() => {
        getRolesList();
    }, [subAdminRole]);

    useEffect(() => {
        const requiredTab = constant.ROLE_FOR.find((item) => item.id === assignedTo);
        if (requiredTab && subAdminRole.id !== assignedTo) {
            setSubAdminRole(requiredTab);
        }
    }, [assignedTo]);

    return (
        <Wrapper>
            <RoleLayout activeTab={subAdminRole?.id} onClear={(value: string) => onChangeTab(value)} tabs={tabs} />
        </Wrapper>
    );
};

export default Index;
